import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import Layout from './components/Layout/Layout';
import LoadingSpinner from './components/common/LoadingSpinner';
import SemanticSkeleton from './components/common/SemanticSkeleton';
import CookieBanner from './components/CookieBanner';
import TrackingScripts from './components/utils/TrackingScripts';
import SiteIdentity from './components/utils/SiteIdentity';

// Lazy load pages for better performance
const HomePage = lazy(() => import('./pages/HomePage'));
const KoupitBytPage = lazy(() => import('./pages/KoupitBytPage'));
const ProdatBytPage = lazy(() => import('./pages/ProdatBytPage'));
const SpolupracePage = lazy(() => import('./pages/SpolupracePage'));
const RychlyVykupPage = lazy(() => import('./pages/RychlyVykupPage'));
const RealizacePage = lazy(() => import('./pages/RealizacePage'));
const PripravujemePage = lazy(() => import('./pages/PripravujemePage'));
const KontaktPage = lazy(() => import('./pages/KontaktPage'));
const PropertyDetailPage = lazy(() => import('./pages/property/PropertyDetailPage'));
const NotFoundPage = lazy(() => import('./pages/NotFoundPage'));
const GDPRPage = lazy(() => import('./pages/GDPRPage'));
const CookiesPage = lazy(() => import('./pages/CookiesPage'));

function App() {
  return (
    <AppProvider>
      <Router>
        <TrackingScripts />
        <SiteIdentity />
        <Suspense fallback={<SemanticSkeleton />}>
          <Routes>
            {/* Public routes with main layout */}
            <Route element={<Layout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/koupit-byt" element={<KoupitBytPage />} />
              <Route path="/prodat-byt" element={<ProdatBytPage />} />
              <Route path="/spoluprace" element={<SpolupracePage />} />
              <Route path="/rychly-vykup" element={<RychlyVykupPage />} />
              <Route path="/realizace" element={<RealizacePage />} />
              <Route path="/pripravujeme" element={<PripravujemePage />} />
              <Route path="/kontakt" element={<KontaktPage />} />
              <Route path="/byt/:slug" element={<PropertyDetailPage />} />
              <Route path="/gdpr" element={<GDPRPage />} />
              <Route path="/cookies" element={<CookiesPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Route>
          </Routes>
        </Suspense>
        <CookieBanner />
      </Router>
    </AppProvider>
  );
}

export default App;
